import { useEffect, useRef, useState } from 'react';

function useInViewWithDelay(options, delay = 1000) {
  const [isInView, setIsInView] = useState(false);
  const ref = useRef(null);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
          setIsInView(true);
        }, delay);
      } else {
        clearTimeout(timeoutRef.current);
        setIsInView(false);
      }
    }, options);

    const element = ref.current;
    if (element) {
      observer.observe(element);
    }

    return () => {
      if (element) {
        observer.unobserve(element);
        clearTimeout(timeoutRef.current);
      }
    };
  }, [ref, options, delay]);

  return [ref, isInView];
}

export default useInViewWithDelay;
